import { jsx } from "react/jsx-runtime";
import MPaper from "@mui/material/Paper";
import styled from "@mui/material/styles/styled";
import React from "react";
import { filterValidProps } from "../../shared/helpers";
import { useCurrentColor } from "../../shared/hooks/current-color";
const CustomPaper = styled(MPaper)((props) => {
  const { color, bg, sx, deprecatedSX, theme } = props;
  return {
    background: bg,
    backgroundColor: bg,
    color,
    ...deprecatedSX ?? {},
    ...sx ?? {}
  };
});
const Paper = React.forwardRef(
  (props, ref) => {
    const {
      color: rawColor,
      bg: rawBg,
      sx,
      deprecatedSX,
      fill,
      ...restProps
    } = props;
    const newProps = filterValidProps(restProps || {});
    const newSx = filterValidProps(sx || {});
    const {
      ctx,
      color,
      bg,
      passCtx,
      Provider
    } = useCurrentColor(rawBg, rawColor, fill);
    const boxContent = /* @__PURE__ */ jsx(
      CustomPaper,
      {
        ref,
        sx: newSx,
        deprecatedSX,
        color,
        bg,
        ...newProps
      }
    );
    if (passCtx)
      return /* @__PURE__ */ jsx(Provider, { value: ctx, children: boxContent });
    return boxContent;
  }
);
var Paper_default = Paper;
export {
  Paper_default as default
};
